import { withStyles } from '@material-ui/styles';
import TopThreeReportCell from './TopThreeReportCell';
import styles from './styles';

const styledComponent = withStyles(styles)(TopThreeReportCell);

export default styledComponent;
